<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast-container">
      <div class="toast" :class="type">
        <div class="toast-icon">
          <i :class="getToastIcon()"></i>
        </div>
        <div class="toast-content">
          <div class="toast-title">{{ title }}</div>
          <div class="toast-message">{{ message }}</div>
        </div>
        <button class="toast-close" @click="close">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AppToast',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'info',
      validator: value =>
        ['success', 'error', 'warning', 'info'].includes(value)
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 3000
    }
  },
  watch: {
    visible (newValue) {
      if (newValue && this.duration > 0) {
        this.setAutoClose()
      }
    }
  },
  data () {
    return {
      timeout: null
    }
  },
  methods: {
    getToastIcon () {
      switch (this.type) {
        case 'success':
          return 'fas fa-check-circle'
        case 'error':
          return 'fas fa-exclamation-circle'
        case 'warning':
          return 'fas fa-exclamation-triangle'
        default:
          return 'fas fa-info-circle'
      }
    },
    setAutoClose () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.close()
      }, this.duration)
    },
    close () {
      clearTimeout(this.timeout)
      this.$emit('close')
    }
  },
  beforeUnmount () {
    clearTimeout(this.timeout)
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  min-width: 300px;
}

.toast {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px 20px;
  animation: slide-up 0.3s ease;
}

.toast-icon {
  font-size: 24px;
  margin-right: 12px;
  flex-shrink: 0;
}

.toast-content {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.toast-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 2px;
}

.toast-message {
  font-size: 14px;
  color: #666;
}

.toast-close {
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  font-size: 16px;
  margin-left: 12px;
  padding: 4px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.toast-close:hover {
  background-color: #f0f0f0;
}

.toast.success {
  border-left: 4px solid #28a745;
}

.toast.success .toast-icon {
  color: #28a745;
}

.toast.error {
  border-left: 4px solid #dc3545;
}

.toast.error .toast-icon {
  color: #dc3545;
}

.toast.warning {
  border-left: 4px solid #ffc107;
}

.toast.warning .toast-icon {
  color: #ffc107;
}

.toast.info {
  border-left: 4px solid #17a2b8;
}

.toast.info .toast-icon {
  color: #17a2b8;
}

@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
